const simuladores = [
  {
    titulo: "Simulador de Hash",
    descripcion: "Explora cómo se generan los hash y cómo responden a los cambios de datos.",
    imagen: "https://github.com/AppsDevsLeon/ImagesProject/blob/main/simuladores/ChatGPT%20Image%206%20ago%202025,%2023_10_07.png?raw=true",
    botonTexto: "Ver Simulador",
    url: "/course/simulador-hash"
  },
  {
    titulo: "Simulador de Bloques",
    descripcion: "Crea y enlaza bloques para entender la inmutabilidad en blockchain.",
    imagen: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/simuladores/ChatGPT%20Image%206%20ago%202025%2C%2023_14_33.png",
    botonTexto: "Ver Simulador",
    url: "/course/simulador-bloques"
  },
  {
    titulo: "Simulador de Red Blockchain",
    descripcion: "Simula nodos, propagación de transacciones y consenso de red.",
    imagen: "https://raw.githubusercontent.com/AppsDevsLeon/ImagesProject/refs/heads/main/simuladores/ChatGPT%20Image%206%20ago%202025%2C%2023_20_18.png",
    botonTexto: "Ver Simulador",
    url: "/course/simulador-red"
  }
];

export default simuladores;
